import { useState,useEffect } from "react";
import MyToken from "../my-token";
import {
  Steps,
  Input,
  // InputNumber,
  Button,
  // Upload,
  InputNumber,
  message,
  Checkbox,
} from "antd";
import type { CheckboxProps } from 'antd';
import "./index.less";
import UploadFile from '../../components/UploadFile';
import { ethers } from 'ethers';
import apiService from '../../services/tokenAjax'
import deployefinish1 from '../../img/deployefinish1.png'
import useGetUserInfo from '../../hooks/useGetUserInfo'
import { Erc20ContractBytecode } from "../../contract/Erc20ContractBytecode";
import { Erc20ContractABI } from "../../contract/Erc20ContractABI";
import { useI18n } from '../../contexts/I18nContext';
import NumericInput from "../../components/NumericInput";
import ConnectWalletPopup from "../../components/ConnectWalletPopup";
import { useDispatch,useSelector } from 'react-redux'
import { loginReducer } from '../../store/userReducer'
import { setNowNetwork  } from '../../store/networkReducer'
import { useTranslation } from "react-i18next";


// const { Dragger } = Upload;
declare let window: any
declare let e: any
const TokenCreate = () => {
  // 替换为你的合约 ABI 和 Bytecode
  // const { t, translating, language } = useI18n();
  const { t, i18n }: { t: any,i18n:any } = useTranslation();
  const [step, setStep] = useState<number>(0);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [name, setName] = useState('');
  const [symbol, setSymbol] = useState('');
  const [totalSupply, setTotalSupply] = useState('0');
  const [decimals, setDecimals] = useState(18);
  const [butbgcolor, setButbgcolor] = useState('#1F2024')
  const [description, setDescription] = useState('')
  const [contractAddress, setContractAddress] = useState('');
  const [error, setError] = useState('');
  const [isDeploying, setIsDeploying] = useState(false);
  const [checkEd, setCheckEd] = useState(true);
  const [sendUpUrl, setSendUpUrl] = useState('')
  const [thash, setThash] = useState('')
  const [tnonce, setTnonce] = useState(0)
  const [isFocused, setIsFocused] = useState(false);
  const [isShowPop, setIsShowPop] = useState(false); // 是否链接显示弹窗
  const [tokenAddress, setTokenAddress] = useState('')  //发型的代币地址
  const nowNetwork = useSelector((state: any) => state.network.nowNetwork);

  const [titleActive, setTitleActive] = useState(0);
    const { username, nickname } = useGetUserInfo()
    
  const selectStep = (step: number) => {
    setStep(step);
  };

  const onChange: CheckboxProps['onChange'] = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setCheckEd(e.target.checked)
};

  useEffect(() => {
    if (!isEmpty(name) && !isEmpty(symbol) && parseInt(totalSupply) >0 && !isEmpty(decimals)) {
      setButbgcolor('#23D8F0')
      setBtnDisabled(true)
      // console.log(btnDisabled)
      // console.log(`name:${name},symbal:${symbol},total:${totalSupply},decimals:${decimals}`)
    } else {
      setButbgcolor('#1F2024')
    }
    // console.log(`checkEd:${checkEd}`)
    }, [name,symbol,totalSupply,decimals,checkEd])
  
  const isEmpty = (value:any) => {
      // 处理 null 或 undefined
      if (value === null || value === undefined) {
        return true;
      }
      // 处理字符串（包括空白字符）
      if (typeof value === 'string') {
        return value.trim() === '';
      }
      // 其他类型默认视为非空（如数字、对象等）
      return false;
  };
  
  const validateInputs = () => {
    if (!name || !symbol || !totalSupply || !decimals) {
      setError('All fields are required');
      return false;
    }
    if (isNaN(parseInt(totalSupply)) || isNaN(decimals)) {
      setError('Total Supply and Decimals must be numbers');
      return false;
    }
    if (!Number.isInteger(Number(totalSupply)) || Number(totalSupply) <= 0) {
      setError('Total Supply must be a positive integer');
      return false;
    }
    if (decimals < 0 || decimals > 255) {
      setError('Decimals must be between 0 and 255');
      return false;
    }
    return true;
  };

  const handleDeploy = async () => {
    if (!validateInputs()) return;
    
    if (!window.ethereum) {
      setError('Please install MetaMask!');
      return;
    }

    if (!checkEd) {
      message.error(`请勾选 我已确认以上信息！`);
      return;
    }

    setIsDeploying(true);
    // setShowing('none');
    setError('');

    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();

      // const factory = new ethers.ContractFactory(contractABI, contractBytecode, signer);
      const factory = new ethers.ContractFactory(Erc20ContractABI, Erc20ContractBytecode, signer);
      const contract = await factory.deploy(
        name,
        symbol,
        parseInt(totalSupply), // 转换为整数
        decimals
      );
      // const address = contract.address;
      console.log(`合约地址: ${contract.address}`);
      setTokenAddress(contract.address)
      console.log("部署合约的交易详情")
      console.log(JSON.stringify(contract.deployTransaction));
      const { hash, nonce } = contract.deployTransaction;
      setThash(hash)
      setTnonce(nonce)
      console.log(`区块高度：${nonce},交易哈希：${hash}`);
      console.log("\n等待合约部署上链")
      await contract.deployed();
      console.log("合约已上链")
      setContractAddress(contract.address);
      apiService.createItem('token/setUserTokenInfo', {
        appKey: '3269830f92740058b8b32a1f863b37581a5cc1fe421d68c7fcc5a36358d89a63', uid: `${username}`, name: `${name}`, symbol: `${symbol}`,
        tokenAmount: `${totalSupply}`, tokenPrecision: `${decimals}`, contractAddress: `${contract.address}`, tokenDescription: `${description}`, hash: `${hash}`, nonce: `${nonce}`,
        logoUrl: `${sendUpUrl}`
      });
      message.success(`发币成功！合约地址: ${contract.address}`)
      selectStep(2)
    } catch (err:any) {
      setError(err.message || 'Deployment failed');
      console.log(error)
    } finally {
      setIsDeploying(false);
    }
  };

  const dispatch = useDispatch();
  const showWalletPop = async()=>{
    try {
      const accounts = await (window as any).ethereum.request({ method: "eth_requestAccounts" });
      localStorage.setItem("address", accounts[0]);
      dispatch(loginReducer({ 'username':accounts[0], 'nickname':'OK' }))
      setIsShowPop(false)
    } catch (error) {
      console.error("钱包连接错误:", error);
    }
  }
  const tojuUrl = ()=>{
    // setStep(0)
    let urlList = ['https://explorer.juscan.io/','https://testnet.juscan.io/']
    let url = urlList[localStorage.getItem('chanIndex') || 0]
    window.open(`${url}token/${tokenAddress}`)
  }
  const addToken = async()=>{
    // setStep(0)
    try {
      if (window.ethereum) {
        const wasAdded = await window.ethereum.request({
          method: "wallet_watchAsset",
          params: {
            type: "ERC20",
            options: {
              address: tokenAddress,
              symbol: symbol,
              decimals: 18,
              // image: tokenImage, // 代币图标（可选）
            },
          },
        });
  
        if (wasAdded) {
          console.log("代币添加成功！");
        } else {
          console.log("用户取消了添加代币");
        }
      } else {
        console.log("请安装 MetaMask 或其他支持的 Web3 钱包");
      }
    } catch (error) {
      console.error("添加代币时出错:", error);
    }
  }
  return (
    <div style={{ display:'flex',flexDirection:'row'}}>
      <div className="wholePage">
        <div className="tokenTitle">
          <span onClick={() => setTitleActive(0)} className={titleActive == 0?'spanActive':''}>{t('HT1')}</span>
          <span onClick={() => setTitleActive(1)} className={titleActive == 1?'spanActive':''}>{t('It51')}</span>
        </div>
      {
        titleActive == 1?<MyToken></MyToken>:
        <div className="token-create">
          <div className="ju-step-container">
            <Steps
              className="ju-step"
              direction="vertical"
              current={step}
              items={[
                {
                  title: `${t('It1')} 1`,
                  description: `${t('It2')}`,
                },
                {
                  title: `${t('It1')} 2`,
                  description: `${t('It3')}`,
                },
                {
                  title: `${t('It1')} 3`,
                  description: `${t('It4')}`,
                },
              ]}
            />
          </div>
          {step === 0 && (
            <div className="token-create-content">
              <div className="content-header">
                <div className="content-header-title" data-translate>{t('It5')}</div>
                <p className="content-header-desc" >
                {t('It6')}
                </p>
              </div>
              <div className="content-body">
                <Input value={name} size="large" placeholder={t('It7')}
                  onChange={(e) => setName(e.target.value)}
                  />
                <p className="input-desc">{t('It8')}</p>
                <Input value={symbol} size="large" placeholder={t('It9')} onChange={(e) => setSymbol(e.target.value)}
                  onFocus={(e) => setIsFocused(true)}
                  />
                <p className="input-desc">{t('It10')}</p>
                <div className="token-card">
                  <div className="token-card-content">
                    <div className="token-card-content-title" data-translate>{t('It11')}</div>
                    <Input value={totalSupply} size="large" placeholder="" onChange={(e) => setTotalSupply(e.target.value)}
                      style={{ width: 230, height: 50, color: '#fff', backgroundColor: '#1F2024', border: 'none',marginLeft:10,fontSize:26}}
                    />
                    {/* <NumericInput/> */}
                    <div className="token-card-content-desc" >
                    {t('It12')}
                    </div>
                  </div>
                  <div className="token-card-content">
                    <div className="token-card-content-title" data-translate>{t('It13')}</div>
                    <Input value={decimals} size="large" placeholder="Decimals 18" disabled={true} onChange={(e) => setDecimals(parseInt(e.target.value))}
                      style={{ width: 230, height: 50, color: '#fff', backgroundColor: '#1F2024', border: 'none',marginLeft:10,fontSize:26}}
                    />
                    <div className="token-card-content-desc">
                    {t('It14')}
                    </div>
                  </div>
                </div>
                <div className="token-card-divider">
                  <div className="divider-left">
                    <div className="divider-left-title" data-translate>{t('It15')}</div>
                    <div className="divider-left-desc">{t('It16')}</div>
                  </div>
                  <Button
                    rootClassName="divider-right"
                    ghost
                    onClick={() => setShowMore(!showMore)}
                  >
                    {showMore ? t('It50') : t('It17')}
                  </Button>
                </div>
                {showMore && (
                  <div className="token-expand">
                    <Input.TextArea
                      value={description}
                      onChange={(e)=>{setDescription(e.target.value)}}
                      autoSize={{ minRows: 4, maxRows: 6 }}
                      rootClassName="token-expand-input"
                    />
                    <p className="token-expand-desc">
                      {t('It19')}
                    </p>
                    <div className="ant-upload-drag">
                          {isEmpty(sendUpUrl)?
                          <UploadFile onSendUrl={setSendUpUrl} /> : <img src={sendUpUrl} style={{ width: '116px', height: '116px',display:'block',borderRadius:'50%'}}/>
                      }
                      {!isEmpty(sendUpUrl) ?
                        <Button shape="round" style={{ height: 24,width:70,border:'1px solid #35363A',borderColor:'#35363A',backgroundColor:'#1F2024',color:'#9B9FA8',left:'50px',top:'50px'}} block onClick={() => setSendUpUrl('')}>Remake</Button>: <span></span>
                      }
                    </div>
                  </div>
                )}
                <Button shape="round" block onClick={() => setStep(1)}
                      style={{ height: '54px', backgroundColor: `${butbgcolor}`, overflow: 'hidden', border: 'none', fontSize: 28, color: '#42454C',marginTop:20}} data-translate>
                        {t('It18')}
                    </Button>
              </div>
            </div>
          )}
          {step === 1 && (
            <div className="token-create-content">
              <div className="content-header">
                <div className="content-header-title">
                {t('It22')}
                </div>
                <p className="content-header-desc">
                {t('It23')}
                </p>
              </div>
              <div className="token-info-container">
                {/* <img src="/btc.png" alt="" />
                */}
                <img src={sendUpUrl} style={{ width: '116px', height: '116px',borderRadius:'50%'}} />
                <p className="token-info-name">{name}</p>
                <p className="token-info-symbol">{symbol}</p>
                <div className="token-info-card">
                  <div className="token-info-card-item">
                    <span className="item-left">{t('It24')}</span>
                    <span className="item-right">{t('It29')}</span>
                  </div>
                  <div className="token-info-card-item">
                    <span className="item-left">{t('It25')}</span>
                    <span className="item-right">{ totalSupply }</span>
                  </div>
                  <div className="token-info-card-item">
                    <span className="item-left">{t('It27')}</span>
                    <span className="item-right">{ decimals }</span>
                  </div>
                </div>
              </div>
              <div className="token-deploy-info">
                <div className="deploy-info-title">{t('It30')}</div>
                <div className="deploy-info-content">
                  <div className="deploy-info-item">
                    <span className="item-left">{t('It31')}</span>
                    <span className="item-right"> {nowNetwork}</span>
                  </div>
                  <div className="deploy-info-item">
                    <span className="item-left">{t('It32')}</span>
                    <span className="item-right">{t('It35')}</span>
                  </div>
                  <div className="deploy-info-item">
                    <span className="item-left">{t('It33')}</span>
                    <span className="item-right">≈ 0.001 JU</span>
                  </div>
                </div>
                {/* <Checkbox rootClassName="deploy-info-checkbox" onChange={(e) => setCheckEd(true)}>
                  我已确认以上信息
                </Checkbox> */}
                <Checkbox style={{color:'#fff',marginTop:20}} checked={checkEd} onChange={onChange}>{t('It36')}</Checkbox>
                <div className="deploy-info-desc">
                {t('It37')}
                </div>
              </div>
              {username?
                <div className="token-deploy-btn">
                  <Button
                    size="large"
                    rootClassName="previous-btn"
                    style={{display:`${checkEd?'none':'block'}`}}
                    block
                    onClick={() => setStep(0)}
                  >
                    {t('It38')}
                  </Button>
                  <Button
                    size="large"
                    rootClassName="deploy-btn"
                    block
                    onClick={handleDeploy}
                    loading={isDeploying}
                  >
                    {isDeploying ? `${t('HT1')}...` : t('HT1')}
                  </Button>
                </div>:
                   <div className="token-deploy-btn">
                    <Button
                      size="large"
                      rootClassName="deploy-btn"
                      block
                      onClick={()=>setIsShowPop(true)}
                    >
                      {t('It49')}
                    </Button>
                    { isShowPop && <ConnectWalletPopup onClose={() => setIsShowPop(false)}  onConnect={showWalletPop} ></ConnectWalletPopup>}
                   </div>
                  }
            </div>
          )}
          {step === 2 && (
            <div className="token-create-content">
              <div className="token-deploy-status">
                <div className="deploy-status-title">
                  {t('It39')}
                </div>
                {/* <img src={sendUpUrl} alt="" /> */}
                <div style={{display:'flex',alignItems:'center',justifyContent:'center',marginTop:20}}>
                  <div style={{
                    backgroundImage: `url(${deployefinish1})`,   width: 277, height: 149, backgroundSize: 'cover',
                    backgroundPosition: 'center', borderRadius: 20,
                  }}>
                    <img src={sendUpUrl} style={{ width: '116px', height: '116px', borderRadius: '50%' }} />
                  </div>
                </div>
                
                <p className="deploy-token-name">{name}</p>
                <p className="deploy-token-symbol">{symbol}</p>
              </div>
              <div className="deploy-info">
                <div className="deploy-info-item">
                  <span className="item-left">{t('It40')}</span>
                  <span className="item-right">{contractAddress.substring(0, 10)}...{contractAddress.slice(-4)}</span>
                </div>
                <div className="deploy-info-item">
                  <span className="item-left">{t('It41')}</span>
                  <span className="item-right">{ tnonce }</span>
                </div>
                <div className="deploy-info-item">
                  <span className="item-left">{t('It42')}</span>
                  <span className="item-right">{ thash.substring(0, 10) }...{thash.slice(-4)}</span>
                </div>
              </div>
              <div className="deploy-btn-group">
                <Button
                  size="large"
                  rootClassName="scan-btn"
                  block
                  onClick={tojuUrl}
                >
                  {t('It43')}
                </Button>
                <Button
                  size="large"
                  rootClassName="add-wallet-btn"
                  block
                  onClick={addToken}
                >
                  {t('It44')}
                </Button>
              </div>
            </div>
          )}
        </div>
      }

      </div>

    </div>
    
  );
};

export default TokenCreate;
